/* MYSTERY BOX — cart drawer: live "N LEFT" for their size + the second-shot offer.
   Mudit, 2026-09-11.

   Mystery-box ONLY. drop-page.js is shared by every drop page, so none of this
   lives there. The offer adds through the page's own size button, so the
   optimistic line, toast, pending state and checkout guard are the proven path.

   STOCK IS READ LIVE from /products/<handle>?view=stock (templates/product.
   stock.liquid) with a unique param every time, because the drop page is
   page-cached and its baked-in counts lag during a busy drop.

   🔴 THE SECOND-UNIT OFFER NEEDS 2+ IN STOCK. Carts do not reserve inventory,
   so the unit in their cart is still counted. With 1 left (Mystery Bag 3XL at
   launch) an offer to add a second fails at Shopify and shows "Couldn't add".

   🔴 "N LEFT" appears only at 5 or fewer, and only for THEIR product and size.

   🔴 "Double your shot" is exact only while the credit bag/box is assigned at
   random across all orders. The copy never says "win" and restates the floor. */
(function () {
  "use strict";
  var box   = document.getElementById("mbUpsell");
  var body  = document.getElementById("cartBody");
  var stock = document.getElementById("mbUpStock");
  var offer = document.getElementById("mbUpOffer");
  var h = document.getElementById("mbUpH");
  var p = document.getElementById("mbUpP");
  var btn = document.getElementById("mbUpBtn");
  if (!box || !body || !btn || !stock || !offer) return;

  var LOW = 5;
  var TIERS = {
    "cult-racing-mystery-box": { unit: "bag", credit: "$250", batch: 131, floor: "$69", price: "$50" },
    "cult-racing-loaded-box":  { unit: "box", credit: "$500", batch: 51,  floor: "$152", price: "$100" }
  };

  var target = null, timer = null, adding = false, seq = 0, obs = null;

  function hideAll() { box.hidden = true; stock.hidden = true; offer.hidden = true; target = null; adding = false; }

  function liveStock(handle) {
    return fetch("/products/" + handle + "?view=stock&_=" + Date.now(), { credentials: "same-origin" })
      .then(function (r) { if (!r.ok) throw new Error("stock " + r.status); return r.text(); })
      .then(function (t) { return JSON.parse(t); });
  }

  /* 🔴 "N LEFT" SITS UNDER THE PRODUCT LINE, in red. Mudit, 2026-09-11: "it
     should be right below the product in the cart in red text". It was first
     built as a badge inside the offer panel, where he did not look for it.
     Every mystery line in the bag gets its own count, for its own size.

     The lines are drawn by drop-page.js (shared by every drop, so not edited)
     with innerHTML, which wipes anything added on each redraw. So this re-adds
     the note after every redraw, matching lines by their remove button's
     data-remove, which is the cart line KEY from /cart.js. */
  /* 🔴 THE TICKER MUST NEVER BLINK. Mudit, 2026-09-11: "the banners sometimes
     disappear / don't show up / click in and out". Cause, measured: every add
     redraws the bag THREE times (optimistic line, server line, /cart.js
     reconcile) and each redraw wipes #cartBody. The note used to come back
     only after a 220ms debounce plus /cart.js plus the stock fetch, so it
     vanished for ~half a second, up to three times per add, and its scroll
     restarted from zero each time.

     Now the note is drawn from the DOM plus a STOCK CACHE, synchronously, in
     the MutationObserver callback, which runs as a microtask BEFORE the
     browser paints. The redraw and the re-added note land in the same frame,
     so nothing ever shows without it. The fetch that follows only refreshes
     the cache. Lines are matched by title + size text, which is on every row
     including the optimistic "Adding" row that has no cart key yet, so a new
     line shows its count the instant it appears. */
  var stockCache = {};   /* variant id -> live count */
  var VARIANTS = {};     /* "Mystery Bag|XXL" -> variant id, read off the size buttons */
  [].forEach.call(document.querySelectorAll(".lot--tier .size-btn[data-variant-id]"), function (b) {
    VARIANTS[(b.dataset.title || "") + "|" + b.textContent.trim()] = String(b.dataset.variantId);
  });
  function mergeStock(stockBy) {
    for (var hh in stockBy) {
      var m = stockBy[hh];
      if (!m) continue;
      for (var v in m) stockCache[v] = m[v];
    }
  }
  function rowVariant(row) {
    var t = row.querySelector(".cart-item__info h4");
    var s = row.querySelector(".cart-item__info p");
    if (!t || !s) return null;
    var size = s.textContent.split("·")[0].replace(/^\s*Size\s+/, "").trim();
    return { id: VARIANTS[t.textContent.trim() + "|" + size] || null, size: size };
  }
  function annotate() {
    var rows = body.querySelectorAll(".cart-item"), i, row, rv, n, info, note, old, msg;
    for (i = 0; i < rows.length; i++) {
      row = rows[i];
      info = row.querySelector(".cart-item__info");
      old = info && info.querySelector(".cart-item__left");
      rv = rowVariant(row);
      n = rv && rv.id ? stockCache[rv.id] : null;
      if (!info || typeof n !== "number" || n < 1 || n > LOW) {
        if (old) old.parentNode.removeChild(old);
        continue;
      }
      msg = n === 1 ? "LAST ONE IN " + rv.size : n + " LEFT IN " + rv.size;
      /* identical note already there: leave it, so the scroll never restarts */
      if (old && old.getAttribute("data-msg") === msg) continue;
      if (old) old.parentNode.removeChild(old);
      /* A BOXED TICKER, not a line of small text. Mudit, 2026-09-11: "really
         small ... boxed with exclamation mark ... a box with text inside that
         is scrolling from left to right to catch attention".
         A fixed "!" cell, then a window whose track holds two identical halves
         and slides -50% -> 0, so the loop is seamless and moves RIGHTWARD as
         asked. The repeated text is aria-hidden; the container carries one
         clean label for screen readers. */
      var half = "", r;
      for (r = 0; r < 4; r++) half += '<span class="cil__msg">' + msg + '</span><span class="cil__sep">/</span>';
      note = document.createElement("div");
      note.className = "cart-item__left";
      note.setAttribute("role", "note");
      note.setAttribute("data-msg", msg);
      note.setAttribute("aria-label", (n === 1 ? "Last one" : n + " left") + " in size " + rv.size);
      /* phase-lock to the page clock, so a note re-added after a redraw picks
         up mid-scroll exactly where the old one was instead of jumping back */
      note.innerHTML = '<span class="cil__bang" aria-hidden="true">!</span>' +
        '<span class="cil__win" aria-hidden="true"><span class="cil__track" style="animation-delay:-' +
        Math.round(performance.now() % 7000) + 'ms">' + half + half + '</span></span>';
      info.appendChild(note);
    }
  }

  function evaluate() {
    var mine = ++seq;
    var cartRef;
    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartRef = cart;
        var handles = [], i, h;
        for (i = 0; i < cart.items.length; i++) {
          h = cart.items[i].handle;
          if (TIERS[h] && handles.indexOf(h) < 0) handles.push(h);
        }
        if (!handles.length) return {};
        return Promise.all(handles.map(function (hh) {
          return liveStock(hh).then(function (m) { return [hh, m]; }, function () { return [hh, null]; });
        })).then(function (pairs) {
          var o = {}; pairs.forEach(function (pr) { o[pr[0]] = pr[1]; }); return o;
        });
      })
      .then(function (stockBy) {
        if (mine !== seq) return;
        var cart = cartRef;
        /* 🔴 takeRecords(), NOT a boolean flag. MutationObserver callbacks run
           later, as a microtask, so a flag set around annotate() is already
           false by the time the callback fires and our own edit re-triggered
           evaluate() for ever: measured at 6 /cart.js requests in 3 idle
           seconds. takeRecords() discards the records our edit just queued,
           synchronously, before the callback can see them. */
        mergeStock(stockBy);
        for (var sh in stockBy) syncTier(sh, stockBy[sh]);
        annotate();
        if (obs) obs.takeRecords();

        var qty = {}, pick = null, i, k;
        for (i = 0; i < cart.items.length; i++) {
          var l = cart.items[i];
          if (TIERS[l.handle]) qty[l.handle] = (qty[l.handle] || 0) + l.quantity;
        }
        /* 🔴 THE LOADED BOX ALWAYS WINS. With both products in the bag the offer
           used to follow the newest line, so box-then-bag switched the pitch
           DOWN to the $50 bag. Mudit, 2026-09-11: "just show the more expensive
           box". Within a tier Shopify lists lines newest first. */
        var PRIORITY = ["cult-racing-loaded-box", "cult-racing-mystery-box"];
        for (k = 0; k < PRIORITY.length && !pick; k++) {
          for (i = 0; i < cart.items.length; i++) {
            if (cart.items[i].handle === PRIORITY[k]) { pick = cart.items[i]; break; }
          }
        }
        stock.hidden = true;   /* the count now lives under the product line */
        if (!pick) { offer.hidden = true; box.hidden = true; target = null; return; }

        var t = TIERS[pick.handle];
        var map = stockBy[pick.handle];
        var n = map && typeof map[String(pick.variant_id)] === "number" ? map[String(pick.variant_id)] : null;
        var size = pick.variant_title && pick.variant_title !== "Default Title" ? pick.variant_title : "";
        var sb = document.querySelector('.lot--tier .size-btn[data-variant-id="' + pick.variant_id + '"]');
        /* a second unit must actually be addable: carts do not reserve stock, so
           the one in the bag still counts, and 1 left means no second */
        var canAdd = !!sb && !sb.disabled && !sb.classList.contains("is-out") && (n === null || n >= 2);
        var showOffer = qty[pick.handle] === 1 && canAdd;
        if (showOffer) {
          h.textContent = "Double your shot at the " + t.credit + ".";
          p.textContent = "The " + t.credit + " is sealed in 1 of " + t.batch + " " + t.unit + (t.unit === "box" ? "es" : "s") +
            ". Grab a second and you are holding two. Every " + t.unit + " still clears " + t.floor + " in gear.";
          btn.textContent = "Add a second " + t.unit + (size ? " (" + size + ")" : "") + " · " + t.price;
          btn.disabled = false; adding = false; target = sb;
        } else { target = null; }
        offer.hidden = !showOffer;
        box.hidden = !showOffer;
      })
      .catch(function () { if (mine === seq) hideAll(); });
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(evaluate, 220); }

  btn.addEventListener("click", function () {
    if (!target || adding) return;
    adding = true;                 /* one tap, one unit */
    btn.disabled = true;
    btn.textContent = "Adding…";
    target.click();                /* the page's own add path */
  });

  /* 🔴 ignore our own edits: annotate() inserts nodes into #cartBody, and a
     naive observer would re-run evaluate() on them for ever */
  obs = new MutationObserver(function (records) {
    /* belt and braces: a batch that only touched our notes is ignored too */
    for (var i = 0; i < records.length; i++) {
      var r = records[i], nodes = [].slice.call(r.addedNodes).concat([].slice.call(r.removedNodes));
      for (var j = 0; j < nodes.length; j++) {
        if (!(nodes[j].classList && nodes[j].classList.contains("cart-item__left"))) {
          annotate();            /* same frame as the redraw: no blink */
          obs.takeRecords();
          schedule();            /* then refresh the counts */
          return;
        }
      }
    }
  });
  obs.observe(body, { childList: true, subtree: true });
  /* LIVE TIER PANEL: Remaining count + "S SOLD OUT" tags under it. Mudit,
     2026-09-11. The page is cached and sizes go mid-visit, so the Liquid
     values are only first paint; this keeps them current.
     A size that sells out while the page is open is also DISABLED, so a tap
     cannot end in "Couldn't add". Never re-enabled here: drop-page.js only
     binds buttons that were enabled at load, so a revived button would be dead. */
  function syncTier(handle, map) {
    if (!map) return;
    var lot = document.querySelector('.lot--tier[data-handle="' + handle + '"]');
    if (!lot) return;
    var total = 0, gone = [], v;
    for (v in map) if (map[v] > 0) total += map[v];
    [].forEach.call(lot.querySelectorAll(".size-btn[data-variant-id]"), function (b) {
      var n = map[String(b.dataset.variantId)];
      if (typeof n !== "number" || n > 0) return;
      gone.push(b.textContent.trim());
      if (!b.disabled) { b.disabled = true; b.classList.add("is-out"); b.setAttribute("aria-disabled", "true"); }
    });
    var big = lot.querySelector(".tier__big");
    if (big) big.textContent = total;
    var ul = lot.querySelector("[data-soldout]");
    if (ul) {
      var html = gone.map(function (s) { return "<li>" + s.replace(/[<>&"]/g, "") + " sold out</li>"; }).join("");
      if (ul.innerHTML !== html) ul.innerHTML = html;
      ul.hidden = !gone.length;
    }
  }
  function pollTiers() {
    Object.keys(TIERS).forEach(function (hh) {
      liveStock(hh).then(function (m) {
        var o = {}; o[hh] = m; mergeStock(o); syncTier(hh, m);
        annotate(); if (obs) obs.takeRecords();
      }, function () {});
    });
  }
  /* warm the cache at load, so the very first add shows its count instantly,
     then keep the panel current every 30s while the tab is actually visible */
  pollTiers();
  setInterval(function () { if (!document.hidden) pollTiers(); }, 30000);
  schedule();
})();
